import { axiosInstance } from "@helpers/axios-instance";
import type { DataAwareResponse, Tranch } from "@/types/types";
import { useQueryWithValidation } from "./useQueryWithValidation";

export function useLTIPTranch(ltipExternalCode: string | undefined) {
  return useQueryWithValidation({
    queryKey: [String(ltipExternalCode)],
    queryFn: async () => {
      const data = await axiosInstance({
        method: "GET",
        url:  `Salesforce/LTIPTranch/${ltipExternalCode}`,
      });
      return data.data as DataAwareResponse<Tranch[]>;
    },
    enabled: !!ltipExternalCode,
  });
}
